// extracted by mini-css-extract-plugin
export default {"tableAvatar":"incremental_tableAvatar__f3PaO","tableAvatar__img":"incremental_tableAvatar__img__Rd2+c","rank":"incremental_rank__rHDrV","rankDown":"incremental_rankDown__X2gCh"};